import * as FeatureHubReact from '@feature-hub/react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as styled from 'styled-components';
import * as ReactHelmetAsync from 'react-helmet-async';

export const externals = {
  react: React,
  'react-dom': ReactDOM,
  'styled-components': styled,
  '@feature-hub/react': FeatureHubReact,
  'react-helmet-async': ReactHelmetAsync,
};
